/**
 * A time slot (start and end time) of a day.
 */
export interface TimeSlot {
  /**
   * The start time of the time slot in 24-hour format (e.g. 13:00)
   */
  start: string;

  /**
   * The end time of the time slot in 24-hour format (e.g. 13:00)
   * Must be after the start time
   */
  end: string;
}
